var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1623_1302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0473 3.73107C16.4279 4.00279 15.7679 4.18289 15.0798 4.27034C15.7877 3.84767 16.328 3.18348 16.582 2.38292C15.922 2.77644 15.1932 3.0544 14.4166 3.20951C13.7899 2.5422 12.8967 2.12891 11.9223 2.12891C10.0317 2.12891 8.50973 3.66341 8.50973 5.54457C8.50973 5.81525 8.53264 6.07551 8.58885 6.32328C5.74992 6.18482 3.23788 4.82417 1.55035 2.75145C1.25573 3.2626 1.08292 3.84767 1.08292 4.4775C1.08292 5.66013 1.69193 6.70846 2.59972 7.31539C2.05109 7.30498 1.51287 7.1457 1.05689 6.89481C1.05689 6.90522 1.05689 6.91875 1.05689 6.93229C1.05689 8.59171 2.24056 9.97006 3.79276 10.2876C3.5148 10.3636 3.21186 10.4 2.89746 10.4C2.67884 10.4 2.45814 10.3875 2.25097 10.3417C2.69342 11.694 3.94892 12.6882 5.44177 12.7205C4.27997 13.6293 2.80481 14.1769 1.20785 14.1769C0.927804 14.1769 0.659215 14.1644 0.390625 14.1301C1.90326 15.1055 3.69594 15.6625 5.62916 15.6625C11.9129 15.6625 15.3484 10.4573 15.3484 5.94538C15.3484 5.79443 15.3432 5.64868 15.3359 5.50397C16.0136 5.02301 16.583 4.42233 17.0473 3.73107Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1623_1302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6567,
    height: 16.6567,
    fill: "white",
    transform: "translate(0.390625 0.566406)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.641c3595d1d51e958b87f6c8fddf03af.svg";
export { ForwardRef as ReactComponent };